// import React from 'react';

function Footer() {
    const date = new Date();
    const year = date.getFullYear()
    return(
        <div className='ftr'>
            <div className='container'>

                <p>&copy; Copyright {year}. All rights reserved.</p>

            </div>

        </div>
    )
}

export { Footer } 
